import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("Uncaught Error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    handleReset = () => {
        // Clear Local Storage to remove potentially corrupted state
        localStorage.clear();
        sessionStorage.clear();
        // Force Reload
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={{
                    padding: '40px',
                    textAlign: 'center',
                    backgroundColor: '#0f172a',
                    color: 'white',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontFamily: 'sans-serif'
                }}>
                    <h1 style={{ color: '#ff4d4d', fontSize: '2rem', marginBottom: '20px' }}>Algo salio mal</h1>

                    <div style={{
                        backgroundColor: 'rgba(0,0,0,0.3)',
                        padding: '20px',
                        borderRadius: '8px',
                        marginBottom: '30px',
                        maxWidth: '80%',
                        overflow: 'auto',
                        textAlign: 'left'
                    }}>
                        <p style={{ color: '#ffd700', fontWeight: 'bold' }}>{this.state.error && this.state.error.toString()}</p>
                        <pre style={{ fontSize: '0.8rem', opacity: 0.7 }}>
                            {this.state.errorInfo && this.state.errorInfo.componentStack}
                        </pre>
                    </div>

                    <p>Es posible que haya datos guardados corruptos en tu navegador.</p>

                    <button
                        onClick={this.handleReset}
                        style={{
                            marginTop: '20px',
                            padding: '12px 24px',
                            fontSize: '1rem',
                            backgroundColor: '#3b82f6',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
                        }}
                    >
                        🧹 Limpiar Caché y Reiniciar
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
